import type { SyncedTax } from '@/types/api';

interface TaxFormProps {
  formData: Partial<SyncedTax>;
  onChange: (data: Partial<SyncedTax>) => void;
}

export function TaxForm({ formData, onChange }: TaxFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
        <input
          type="text"
          value={formData.name || ''}
          onChange={(e) => onChange({ ...formData, name: e.target.value })}
          className="input w-full"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Rate (%) *</label>
        <input
          type="number"
          step="0.01"
          value={formData.rate ?? ''}
          onChange={(e) => onChange({ ...formData, rate: parseFloat(e.target.value) || 0 })}
          className="input w-full"
          required
        />
      </div>
    </div>
  );
}
